// extracted by mini-css-extract-plugin
export default {"test":"category_test__Y1Mp5","inner":"category_inner__2qESu"};